// src/contexts/LoaderContext.js
import React, { createContext, useState, useContext } from 'react';

const LoaderContext = createContext();

export const useLoader = () => useContext(LoaderContext);

export const LoaderProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);

  const startLoader = () => {
    setLoading(true);
  };
  const stopLoader = () => {
    setLoading(false);
  };

  return (
    <LoaderContext.Provider value={{ loading, startLoader, stopLoader }}>
      {children}
    </LoaderContext.Provider>
  );
};